import { isFunction } from '@agilepoint/utils-common';
import { isBrowser } from './env';

declare let window: any;
const requestIdleCallback = isBrowser && isFunction(window.requestIdleCallback) ? window.requestIdleCallback : setTimeout || setTimeout;
const cancelIdleCallback = isBrowser && isFunction(window.cancelIdleCallback) ? window.cancelIdleCallback : clearTimeout || clearTimeout;

export class IntervalTimer {
    private _timerId: any;
    private _timerInterval = 0;
    private _started = false;
    private _idleSchedulerHandle: any;
    private _fireOnlyWhenIdle?: boolean;
    constructor(private readonly callback: Function) { }

    start(interval: number, fireOnlyWhenIdle?: boolean) {
        this._fireOnlyWhenIdle = fireOnlyWhenIdle;
        this._timerInterval = interval;
        if (this._started) {
            return;
        }
        this._started = true;
        this._schedule();
    }

    stop() {
        this._started = false;
        clearTimeout(this._timerId);
    }

    _fireCallback() {
        if (!this._fireOnlyWhenIdle) {
            this.callback();
            return;
        }
        if (this._idleSchedulerHandle) {
            cancelIdleCallback(this._idleSchedulerHandle);
        }
        this._idleSchedulerHandle = requestIdleCallback(this.callback);
    }

    _schedule() {
        if (!this._started) {
            return;
        }
        this._fireCallback();
        this._timerId = setTimeout(() => {
            this._schedule();
        }, this._timerInterval);
    }
}
